import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { regenerateWorkspaceCode } from '../../../../api/workspaces/invite/regenerateWorkspaceCode';

export function useRegenerateWorkspaceCode() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: regenerateWorkspaceCode,
    onSettled: (_data, _error, { workspaceId, workspaceRole }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
    },
    onMutate: ({ workspaceId, workspaceRole }) => {
      queryClient.removeQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
    },
  });
}
